export enum AVIATION_INSURANCE_PATHS {
  AVIATION_HULL_INSURANCE = "/aviation-hull-insurance",
  AVIATION_LIABILITY_INSURANCE = "/aviation-liability-insurance",
  AVIATION_PACKAGE = "/aviation-package",
}
